export default "__VITE_ASSET__hlFXMYMF__"